export default __webpack_public_path__ + "static/media/nephrology.48341507.png";